<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('ShelveName'), sort: 'ShelveName' },
                { title: $t('ProductName'), sort: 'ProductName' },
                { title: $t('Count'), sort: 'Count' },
                { title: $t('Serial'), sort: 'Serial' },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 30%">
                  {{ row.shelveName }}
                </td>
                <td style="width: 40%">
                  {{ row.stockName }}
                </td>
                <td style="width: 11%">
                  {{ row.count }}
                </td>
                <td style="width: 15%">
                  <span v-if="row.stockType == 1">
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-eye"
                      class="custom-border-btn"
                      @click="
                        viewSerials(
                          row.inventoryTransactionId,
                          row.shelveId,
                          row.stockId
                        )
                      "
                      >{{ $t("ViewSerials") }}</vs-button
                    >
                  </span>
                  <span v-else>-</span>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
    <serials-list
      :show="SerialsListPopup"
      @close="closeSerialsListPopup"
      :popupService="popupService"
    ></serials-list>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import SerialsList from "./SerialsList.vue";

export default {
  name: "warehouseManagement_invwetoryTransactions_Items",
  components: {
    DataGrid,
    SerialsList,
  },
  data() {
    var id = this.$route.params.id;
    return {
      gridDataSource: {
        type: "app",
        service: "Inventory/api/InventoryTransactionsQuery/" + id + "/0",
      },
      gridSearchData: {},
      SerialsListPopup: false,
      popupService: "",
    };
  },
  methods: {
    viewSerials(inventoryTransactionId, shelveId, stockId) {
      this.popupService =
        "/Inventory/api/InventoryTransactionsQuery/serials/" +
        inventoryTransactionId +
        "/" +
        shelveId +
        "/" +
        stockId;
      this.SerialsListPopup = true;
    },
    closeSerialsListPopup() {
      this.SerialsListPopup = false;
    },
    onfinish() {
      this.closeSerialsListPopup();
      this.$refs.grid.renderGrid();
    },
  },
};
</script>
